import CircularProgress from '@mui/material/CircularProgress';


export const ProgressIcon: React.VFC<{ size?: number }> = ({ size = 14 }) => (
  <CircularProgress color="inherit" size={size} thickness={6} />
);
